module.exports = __webpack_public_path__ + "img/b-zen-cai.cbc28d31.png";